<template>
  <div>
    <section id="sub_visual" class="pic05">
      <p>이트너스 하우징샵</p>
      <span>We always stand for you</span> </section>
    <main id="page_sub">
      <section id="page_contents" class="sub_con05 clear">
        <h6>안정적 한국 생활<br/>
          정착을 위한  첫걸음</h6>
        <span class="ctext1">이트너스 하우징샵은 대한민국에 거주하는 외국인을 위한 전용 온라인 마켓으로<br/>
      한국생활을 시작하는데 있어 필수인 가전/가구/생필품을 중심으로 엄선하여 제공합니다.</span>
        <p class="ctext2 w75p"><span class="cbig">Why</span><span>etners housingshop?</span></p>
        <!--- 특징 --->
        <div class="clearfix">
          <ul class="platform">
            <li>
              <p><img src="../../assets/images/c_im_17.png" width="104" height="104" alt=""/></p>
              <h6>재한 외국인을 위한 검증된 상품. <br/>최적의 가격!</h6>
              <p>오랜기간 해외주재원 지원 경험을 바탕으로 선호하는 제품을 선정합니다. 대한민국에서 가장 검증된 품질의 제품들을 최적의 가격으로 만나보세요!
              </p>
            <li>
              <p><img src="../../assets/images/c_im_18.png" width="104" height="104" alt=""/></p>
              <h6>웹페이지/제품안내 영문구성</h6>
              <p>외국인 전용 온라인 마켓으로 메뉴와 제품안내 영문화 및 고객 문의사항에 대하여 영어 응대로 서비스를 합니다.</p>
            </li>
            <li>
              <p><img src="../../assets/images/c_im_19.png" width="104" height="104" alt=""/></p>
              <h6>배송/설치 고객 지정일 서비스</h6>
              <p>배송과 설치를 고객이 선택한 지정일에 맞춰 제공함으로써 확실하고 안전한 물품인수를 보장합니다.</p>
            </li>
            <li>
              <p><img src="../../assets/images/c_im_20.png" width="104" height="104" alt=""/></p>
              <h6>국내이사와 해외이사까지 지원</h6>
              <p>부임 후 근무지 변경으로 인한 대한민국 내 이사와 귀국 또는 국외 근무지 변경으로 인한 해외이사까지 최저가 솔루션을 제공합니다.</p>
            </li>
          </ul>
        </div>
        <!--- //특징 --->
        <go-solution :solutionUrl="url" :solCd="solCd" :solGrup="10" :solNm="solNm"></go-solution>
      </section>
    </main>
  </div>
</template>

<script>
  import GoSolution from "../../components/goSolution";
  export default {
    components: {GoSolution},
    data() {
      return{
        url:'http://www.etnershousingshop.com',
        solNm :'이트너스하우징샵',
        solCd : '2002'
      }
    }
  }

</script>
